export function renderBuildNavigationExtractSourceImportsTemplate({
  join,
  toCamelCase,
  joinText
}: {
  join: string
  toCamelCase: string
  joinText: string
}): string {
  return `import type { AdminNavigationItem } from '@admin/types/navigation'
import { ${join} } from 'lucide-react'

export const ${toCamelCase}Nav: AdminNavigationItem[] = [
  {
${joinText}
  }
]
`
}
